export var parentLinks = {
    YOURPROFILE: "Your profile",
    FINDACAR: "Find a car",
    PARTEXCHANGE: "Part exchange",
    CARCARE: "Car care",
    CARFINANCE: "Car finance",
    HOWCINCHWORKS: "How cinch works"
};
